<form>
  <nb-card>
    <nb-card-body>
      <a class="btn-close" (click)="cancel()">x</a>
      <img [src]="imgUrl">
    </nb-card-body>

  </nb-card>
</form>
